import { RequestService } from '../../../../common/services/RequestService';
import { CREATE_TEMPLATE } from '../constants';
import { adjustTemplateById, adjustTemplateSend } from './adjustTemplateById';

export const createTemplateRequest = async (profileId, data) => {
  const response = await RequestService.post(
    CREATE_TEMPLATE,
    adjustTemplateSend(profileId, data)
  );
  return response.data && adjustTemplateById(response.data);
};
